import React, { useState, useEffect } from 'react';

const OptimizedImage = ({ src, alt, className = '', loading = 'lazy', fallback, ...props }) => {
  const isImage = typeof src === 'string';
  const extensionRegex = /\.(jpg|jpeg|png)$/i;
  
  const getInitialSrc = (source) => {
    if (!source) return null;
    if (isImage && extensionRegex.test(source) && !source.startsWith('data:')) {
      return source.replace(extensionRegex, '.webp');
    }
    return source;
  };

  const hasWebp = isImage && extensionRegex.test(src) && !src?.startsWith('data:');
  const [currentSrc, setCurrentSrc] = useState(getInitialSrc(src) || fallback || "https://via.placeholder.com/600x400?text=Image+Missing");
  const [failedAttempts, setFailedAttempts] = useState(0);

  useEffect(() => {
    setCurrentSrc(getInitialSrc(src) || fallback || "https://via.placeholder.com/600x400?text=Image+Missing");
    setFailedAttempts(0);
  }, [src, fallback]);

  const handleError = (e) => {
    if (failedAttempts === 0 && hasWebp) {
      // WebP failed, try the original src
      setCurrentSrc(src);
      setFailedAttempts(1);
    } else if (failedAttempts < 2) {
      // Original src failed (or we didn't have webp), try fallback
      setCurrentSrc(fallback || "https://via.placeholder.com/600x400?text=Image+Missing");
      setFailedAttempts(2);
    } else {
      // Even the fallback failed, nothing more we can do
      const { onError } = props;
      if (onError) onError(e);
    }
  };

  return (
    <img
      src={currentSrc}
      alt={alt || 'Image'}
      className={className}
      loading={loading}
      {...props}
      onError={handleError}
    />
  );
};

export default OptimizedImage;
